Vue.component('empty', {
    template: `
    <div style="padding: 20px;text-align: center;color: #ccc;font-size: 14px;background:#fff;">暂无数据</div>
    `
})
new Vue({
    el: '#market',

    data: {
        cur_type: 'goods', // goods or shop 商品和列表
        hide_showMore: true,
        form: {
            page: 1,
            pagenum: 10
        },
        categories: [],
        shops: [],
        cities: [],
        goodsList: [],
        brands: [],
        city_cur: '全部城市',
        brand_cur: '品牌',
        total: 0,
        form: {
            column_type: 1,
            page: 1,
            pagesize: 10,
            keywords: '',
            cat_id: '0',
            brand_id: '0',
            sort: '1',
            city: ''
        }
    },

    mounted() {
        $('#market').show();
    },

    watch: {
        cur_type: {
            handler(newVal) {
                this.init()
            },
            immediate: true
        }
    },

    methods: {
        init() {
            const type = this.cur_type
            if(type === 'goods') {
                this.getGoods()
            } else if(type === 'shop') {
                this.getShop()
            }
        },

        getGoods() {
            const loadingInstance = ELEMENT.Loading.service({ fullscreen: true }) || null;
            $.ajax({
                type: 'post',
                url: jkas.url('/wxxcx/searchSpecialGoodsXcx'),
                dataType: 'json',
                data: this.form,
                success: res => {
                    const { code, rep_msg } = res
                    if(10 === code) {
                        res.categorys[0].cat_id = String(res.categorys[0].cat_id);
                        res.citys[0].city = String(res.citys[0].city);
                        res.brands[0].brand_id = String(res.brands[0].brand_id);
                        this.categories = res.categorys;
                        this.cities = res.citys;
                        this.brands = res.brands;
                        this.goodsList = res.list;
                        this.total = res.pageinfo.count;
                        this.$nextTick(() => {
                            const cateWrapH = $('.category-wrap').innerHeight();
                            if(cateWrapH > 43) {
                                $('.category .cate-btn').show();
                            }
                        });
                    } else if(code === -1 && rep_msg === '暂无数据') {
                        res.categorys[0].cat_id = String(res.categorys[0].cat_id);
                        res.citys[0].city = String(res.citys[0].city);
                        res.brands[0].brand_id = String(res.brands[0].brand_id);
                        this.categories = res.categorys;
                        this.cities = res.citys;
                        this.brands = res.brands;
                        this.goodsList = res.list;
                        this.tatal = 0;
                        this.$nextTick(() => {
                            const cateWrapH = $('.category-wrap').innerHeight();
                            if(cateWrapH > 43) {
                                $('.category .cate-btn').show();
                            }
                        });
                    } 
                },
                fail: err => console.log(err),
                complete: () => {
                    loadingInstance && loadingInstance.close()
                }
            })
        },

        getShop() {
            const loadingInstance = ELEMENT.Loading.service({ fullscreen: true }) || null;
            $.ajax({
                type: 'post',
                url: jkas.url('/wxxcx/searchSpecialShopsXcx'),
                dataType: 'json',
                data: this.form,
                success: res => {
                    const { code, rep_msg } = res;
                    if(10 === code) {
                        this.shops = res.list
                        this.cities = res.citys
                        this.total = res.pageinfo.count
                    } else if(code === -1 && rep_msg === '暂无数据') {
                        this.shops = res.list
                        this.cities = res.citys
                        this.total = 0
                    }
                },
                fail: err => console.log(err),
                complete: () => {
                    loadingInstance && loadingInstance.close()
                }
            })
        },

        changeCurType(e) {
            const { type } = e.target.dataset || e.srcElement.dataset;
            if(type === this.cur_type || !type) return;
            this.cur_type = type;
            // 每次切换初始化参数
            this.form = {
                column_type: 1,
                page: 1,
                pagesize: 10,
                keywords: '',
                cat_id: '0',
                brand_id: '0',
                sort: '1',
                city: ''
            }
            this.init();
        },

        handleCate(e) {
            let { catid } = e.target.dataset || e.srcElement.dataset;
            if(catid === this.form.cat_id || !catid) return;
            this.$set(this.form, 'cat_id', catid);
            this.init();
        },

        showCate(bol) {
            this.hide_showMore = !bol;
        },

        handleFilter(e) {
            let { filtab, type } = e.target.dataset || e.srcElement.dataset
            if(!filtab || !type) return
            if('price' === type) {
                filtab = filtab === '3' ? '4' : '3'
                this.filter_cur = filtab
                this.$set(this.form, 'sort', filtab)
            } else {
                if(this.filter_cur === filtab) return
                this.$set(this.form, 'sort', filtab)
            }
            this.init()
        },

        currentChange(e) {
            this.form.page = e
            this.init()
        },

        search() {
            this.init()
        },

        handleCity(e) {
            const { id, name } = e.target.dataset || e.srcElement.dataset
            if(name === this.city_cur) return
            this.city_cur = name
            this.form.city = id
            this.init()
        },

        handleBrand(e) {
            const { id, name } = e.target.dataset || e.srcElement.dataset
            if(name === this.city_cur) return
            this.brand_cur = name
            this.form.brand_id = id
            this.init()
        },

        handleShopItem(e) {
            const { shopid, shopidx } = e.target.dataset || e.srcElement.dataset;
            if(!shopid) return
            const loadingInstance = ELEMENT.Loading.service({ fullscreen: true }) || null;
            $.ajax({
                type: 'post',
                url: jkas.url('/wxxcx/collectShops'),
                dataType: 'json',
                data: {
                    shop_id: shopid
                },
                success: res => {
                    const { code, rep_msg } = res;
                    if(-3 === code) {
                        this.$confirm(rep_msg, '提示', {
                            confirmButtonText: '确定',
                            cancelButtonText: '取消',
                            showClose: false,
                            closeOnClickModal: false,
                            showCancelButton: false,
                            type: 'warning',
                            center: true
                        }).then(() => {
                            location.href = jkas.url('/login')
                        })
                        return
                    }
                    if(10 === code || 11 === code) {
                        this.$message({
                            type: 'success',
                            message: rep_msg
                        })
                        this.$set(this.shops[shopidx], 'is_att', code);
                    } else {
                        this.$message({
                            type: 'error',
                            message: rep_msg
                        })
                    }
                },
                fail: err => console.log(err),
                complete: () => {
                    loadingInstance && loadingInstance.close()
                }
            })
        }
    }
})